// App Window types declare a full Betslip on ocBetslip; this package needs a minimal local shape.
// Omit host keys before intersecting so we do not require the full CDN Betslip surface.
export type OcWindow = Omit<Window, 'oc' | 'ocBetslip' | 'ocRenderers' | 'xtremepush' | 'bettingActions'> & {
  bettingActions?: {
    addOrRemoveFromBetslip?: (
      betArray: any[],
      matchBetIds?: any[],
      bookie?: string,
      betOdds?: string,
      betName?: string,
      betLocation?: string,
      subeventName?: string,
      marketName?: string,
    ) => void;
  };
  oc: { betslipAdvertActive: boolean; redirectUrl?: string };
  ocBetslip: {
    [key: string]: unknown;
    addBet: (bet: any) => void;
    getBetCount: () => number;
    isInBetslip: (betId: number) => boolean;
    removeBet: (params: { betId: number }) => void;
    setCallbacks: (callbacks: { setBetCount?: () => void }) => void;
    toggle: () => void;
  };
  ocRenderers: Record<string, (props: unknown) => void>;
  xtremepush?: (action: 'get' | 'set', key: string, value?: string | number) => unknown;
};

export const getOcWindow = (): OcWindow => window as unknown as OcWindow;
